// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"4671712971e43bf4475e","655":"9e932ff8bd5f67a18448"}[chunkId] + ".js";
};